<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印载具条码"
      class="vehicleCode"
      width="1000px"
      top="0">
    <div id="printContent">
      <div v-for="(item, index) in selection" :key="index" class="tableBox">
        <table style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="ewm" rowspan="4">
              <div :id="'qrCode' + item.vehicleNo" align="center"/>
            </td>
            <td class="itemTitle">载具编号</td>
            <td colspan="5">{{item.vehicleNo}}</td>
          </tr>
          <tr>
            <td class="itemTitle">载具名称</td>
            <td colspan="5">{{item.vehicleName}}</td>
          </tr>
          <tr>
            <td class="itemTitle">长</td>
            <td style="text-align: center">{{item.length}}</td>
            <td class="itemTitle">宽</td>
            <td style="text-align: center">{{item.width}}</td>
            <td class="itemTitle">载重</td>
            <td style="text-align: center">{{item.load}}</td>
          </tr>
          <tr>
            <td class="itemTitle">限长</td>
            <td style="text-align: center">{{item.lengthLimit}}</td>
            <td class="itemTitle">限宽</td>
            <td style="text-align: center">{{item.widthLimit}}</td>
            <td/>
            <td/>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    props: {
      selection: {
        type: Array,
        default() {
          return [];
        },
      },
    },

    data() {
      return {
        dialogVisible: false,
      };
    },

    methods: {
      open() {
        this.dialogVisible = true;
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.vehicleNo);
        });
        for (let item of ids) {
          this.$nextTick(() => {
            document.getElementById("qrCode" + item).innerHTML = "";
            this.bindQRCode(item);
          });
        }
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode" + row), {
          text: text,
          width: 50,
          height: 50,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>
<style lang="scss">
.vehicleCode .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.vehicleCode .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.vehicleCode .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.vehicleCode .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
#printContent {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  .tableBox {
    width: 48%;
    border-left: 1px solid #111;
    border-bottom: 1px solid #111;
    margin-bottom: 15px;
    font-size: 12px;
    tr {
      td {
        border: 1px solid #111;
        border-bottom: none;
        border-left: none;
        height: 30px;
        padding: 0 5px;
        &.itemTitle {
          width: 60px;
          text-align: center;
        }
      }
      .ewm {
        width: 120px;
        padding: 5px;
        box-sizing: border-box;
        img {
          width: 100%;
        }
      }
    }
  }
}

@media print {
  #printContent {
    .tableBox {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
</style>
